module.exports = __webpack_public_path__ + "media/images/xpass/markers/inactive/yogasix-73bffba3fcf9b986c04b89ec373f6112.png";